import lessRequire from '../../../../../config/less-require-resolver';
import React from 'react';

lessRequire('modules/statistics/components/table/auto-trash/main.less');

const Table = ({ dataTable, intl }) => {
	const { tableHeaders, paginatedData } = dataTable;
	return (
		<table className="dashboard-table autotrash-table">
			<thead className="dashboard-table__head font-proxima-nova-semibold">
				<tr>
					{
						tableHeaders.map((header, key) =>
							<th key={key} colSpan={header.colSpan || 1}>{intl(header.title)}</th>
						)
					}
				</tr>
			</thead>

			<tbody className="dashboard-table__body">
				{paginatedData.map((value, index) =>
					<tr key={index}>
						<td className="secondary_coll">
							<span>{value.date}</span>
						</td>
						<td className="secondary_coll">
							<span>{value.offer}</span>
						</td>
						<td className="secondary_coll">
							<span>{value.campaign}</span>
						</td>
						<td>
							<span>{JSON.stringify(value.payload)}</span>
						</td>
						<td className="secondary_coll">
							<span>{value.type && value.type.text}</span>
						</td>
					</tr>
				)}
			</tbody>

		</table>
	);
};

export default Table;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/table/auto-trash/main.js